import type { VNode } from 'vue'
import { h } from 'vue'

export function Render(props: { value: VNode }) {
  return h(props.value)
}
